var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5C8.9851 15.5013 9.96074 15.3079 10.8708 14.9309C11.781 14.5539 12.6076 14.0007 13.3032 13.3032C14.0007 12.6076 14.5539 11.781 14.9309 10.8708C15.3079 9.96074 15.5013 8.9851 15.5 8C15.5012 7.0149 15.3078 6.03927 14.9308 5.12916C14.5538 4.21906 14.0007 3.39242 13.3032 2.69675C12.6076 1.99927 11.781 1.44613 10.8708 1.06914C9.96074 0.692146 8.9851 0.49873 8 0.500006C7.0149 0.49875 6.03927 0.692176 5.12916 1.06917C4.21906 1.44616 3.39242 1.99928 2.69675 2.69675C1.99928 3.39242 1.44616 4.21906 1.06917 5.12916C0.692176 6.03927 0.49875 7.0149 0.500006 8C0.49873 8.9851 0.692146 9.96074 1.06914 10.8708C1.44613 11.781 1.99927 12.6076 2.69675 13.3032C3.39242 14.0007 4.21906 14.5538 5.12916 14.9308C6.03927 15.3078 7.0149 15.5012 8 15.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53033 12.3428C8.38968 12.4835 8.19891 12.5625 8 12.5625C7.80109 12.5625 7.61032 12.4835 7.46967 12.3428C7.32902 12.2022 7.25 12.0114 7.25 11.8125C7.25 11.6136 7.32902 11.4228 7.46967 11.2822C7.61032 11.1415 7.80109 11.0625 8 11.0625C8.19891 11.0625 8.38968 11.1415 8.53033 11.2822C8.67098 11.4228 8.75 11.6136 8.75 11.8125C8.75 12.0114 8.67098 12.2022 8.53033 12.3428Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.4375L8 8.4375L8 3.4375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.4375L8 8.4375",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.67d97af45859813b9c64cd61d44536b9.svg";
export { ForwardRef as ReactComponent };